/*=========================================================================================
  File Name: moduleRequestTypeConfigActions.js
  Description: Request Type Config Module Actions

==========================================================================================*/
import requestGQL from "@/http/requests/request";

export default {
	getRequestType({ commit }, {id, list_all_controls}) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.getRequestType(id, list_all_controls)
				.then(response => {
					commit("SET_REQUEST_TYPE", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addDynamicFormField({ commit }, { payload, stepId }) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.addDynamicFormField(payload)
				.then(response => {
					commit("ADD_REQUEST_TYPE_FIELD", {
						payload: response,
						stepId
					});
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateDynamicFormField({ commit }, { payload, stepId }) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.updateDynamicFormField(payload)
				.then(response => {
					commit("UPDATE_REQUEST_TYPE_FIELD", {
						payload: response,
						stepId
					});
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteDynamicFormField({ commit }, { id, stepId }) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.deleteDynamicFormField(id)
				.then(response => {
					commit("DELETE_REQUEST_TYPE_FIELD", {
						id,
						stepId
					});
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	sortDynamicFormField({ commit }, { payload, stepId }) {
		return new Promise((resolve, reject) => {
			// commit change first to optimize ux
			commit("SORT_REQUEST_TYPE_FIELD", {
				stepId,
				payload
			});
			requestGQL.request
				.sortDynamicFormField(payload.map(field => field.id))
				.then(response => {
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addRequestTypeStep({ commit }, payload) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.addRequestTypeStep(payload)
				.then(response => {
					commit("ADD_REQUEST_TYPE_STEP", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateRequestTypeStep({ commit }, payload) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.updateRequestTypeStep(payload)
				.then(response => {
					commit("UPDATE_REQUEST_TYPE_STEP", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteRequestTypeStep({ commit }, stepId) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.deleteRequestTypeStep(stepId)
				.then(response => {
					commit("DELETE_REQUEST_TYPE_STEP", stepId);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchGeneralData({ commit }) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.getGeneral()
				.then(response => {
					commit("SET_GENERAL_DATA", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addRequestTypeStatisticalExpression({ commit }, payload) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.addRequestTypeStatisticalExpression(payload)
				.then(response => {
					commit("ADD_REQUEST_TYPE_STATISTICAL_EXPRESSION", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateRequestTypeStatisticalExpression({ commit }, payload) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.updateRequestTypeStatisticalExpression(payload)
				.then(response => {
					commit("UPDATE_REQUEST_TYPE_STATISTICAL_EXPRESSION", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteRequestTypeStatisticalExpression({ commit }, id) {
		return new Promise((resolve, reject) => {
			requestGQL.request
				.deleteRequestTypeStatisticalExpression(id)
				.then(response => {
					commit("DELETE_REQUEST_TYPE_STATISTICAL_EXPRESSION", id);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
};
